var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExteriorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.179L6.53404 14.1566M26.5 15.179L25.6 14.1566M25.6 14.1566L17.0991 5.23385C16.7146 4.83017 16.0741 4.81898 15.6756 5.20898L6.53404 14.1566M25.6 14.1566V26.5C25.6 27.0523 25.1523 27.5 24.6 27.5H14.4M25.6 14.1566H6.53404M6.53404 14.1566V26.5C6.53404 27.0523 6.98176 27.5 7.53404 27.5H9.6M9.6 27.5V17.821C9.6 17.2687 10.0477 16.821 10.6 16.821H13.4C13.9523 16.821 14.4 17.2687 14.4 17.821V27.5M9.6 27.5H14.4M20.8 16.821H22.2C22.7523 16.821 23.2 17.2687 23.2 17.821V19.2852M20.8 16.821H19.4C18.8477 16.821 18.4 17.2687 18.4 17.821V19.2852M20.8 16.821V21.7494M20.8 21.7494H19.4C18.8477 21.7494 18.4 21.3017 18.4 20.7494V19.2852M20.8 21.7494H22.2C22.7523 21.7494 23.2 21.3017 23.2 20.7494V19.2852M18.4 19.2852H23.2M13.6 22.1708V22.1494C13.6 21.9285 13.4209 21.7494 13.2 21.7494V21.7494C12.9791 21.7494 12.8 21.9285 12.8 22.1494V22.1708C12.8 22.3917 12.9791 22.5708 13.2 22.5708V22.5708C13.4209 22.5708 13.6 22.3917 13.6 22.1708Z",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExteriorIcon);
export default __webpack_public_path__ + "static/media/exterior-icon.55455e6930f9ad2a5aec02e8ea5e5f46.svg";
export { ForwardRef as ReactComponent };